import React from 'react';
import './FancyButton.css';

export type FancyButtonVariant = 'blue' | 'yellow' | 'green' | 'red' | 'purple';

interface FancyButtonProps {
  onClick?: () => void;
  children: React.ReactNode;
  variant?: FancyButtonVariant;
  className?: string;
  style?: React.CSSProperties;
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
}

const FancyButton: React.FC<FancyButtonProps> = ({
  onClick,
  children,
  variant = 'blue',
  className = '',
  style = {},
  type = 'button',
  disabled = false,
}) => {
  return (
    <button
      type={type}
      className={`fancy-btn fancy-btn-${variant} ${className}`}
      style={style}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

export default FancyButton;
